(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["codex-category-children"]) return;
  try {
    
  const solveCollectionRailImageAssignment = function solveCollectionRailImageAssignment(candidateRows){const rows=candidateRows.map(row=>{const firstCandidateByKey=new Map;row.forEach(candidate=>{if(candidate.key&&!firstCandidateByKey.has(candidate.key)){firstCandidateByKey.set(candidate.key,candidate)}});return[...firstCandidateByKey.values()]});if(!rows.length)return[];const keyToColumn=new Map;rows.forEach(row=>{row.forEach(candidate=>{if(!keyToColumn.has(candidate.key)){keyToColumn.set(candidate.key,keyToColumn.size)}})});const realColumnCount=keyToColumn.size;const rowCount=rows.length;const columnCount=realColumnCount+rowCount;const rankWeight=Math.max(1e3,columnCount+1);const dummyCost=1e6;const forbiddenCost=1e9;const costs=rows.map((row,rowIndex)=>{const rowCosts=Array(columnCount).fill(forbiddenCost);row.forEach((candidate,rank)=>{const column=keyToColumn.get(candidate.key);if(column===void 0)return;rowCosts[column]=Math.min(rowCosts[column],rank*rankWeight+column)});rowCosts[realColumnCount+rowIndex]=dummyCost+rowIndex;return rowCosts});const u=Array(rowCount+1).fill(0);const v=Array(columnCount+1).fill(0);const matchedRowByColumn=Array(columnCount+1).fill(0);const previousColumn=Array(columnCount+1).fill(0);for(let row=1;row<=rowCount;row+=1){matchedRowByColumn[0]=row;let currentColumn=0;const minimumReducedCost=Array(columnCount+1).fill(Number.POSITIVE_INFINITY);const usedColumn=Array(columnCount+1).fill(false);do{usedColumn[currentColumn]=true;const currentRow=matchedRowByColumn[currentColumn];let delta=Number.POSITIVE_INFINITY;let nextColumn=0;for(let column=1;column<=columnCount;column+=1){if(usedColumn[column])continue;const reducedCost=costs[currentRow-1][column-1]-u[currentRow]-v[column];if(reducedCost<minimumReducedCost[column]){minimumReducedCost[column]=reducedCost;previousColumn[column]=currentColumn}if(minimumReducedCost[column]<delta){delta=minimumReducedCost[column];nextColumn=column}}for(let column=0;column<=columnCount;column+=1){if(usedColumn[column]){u[matchedRowByColumn[column]]+=delta;v[column]-=delta}else{minimumReducedCost[column]-=delta}}currentColumn=nextColumn}while(matchedRowByColumn[currentColumn]!==0);do{const nextColumn=previousColumn[currentColumn];matchedRowByColumn[currentColumn]=matchedRowByColumn[nextColumn];currentColumn=nextColumn}while(currentColumn!==0)}const assignedColumnByRow=Array(rowCount).fill(-1);for(let column=1;column<=columnCount;column+=1){const row=matchedRowByColumn[column];if(row>0)assignedColumnByRow[row-1]=column-1}return rows.map((row,rowIndex)=>{const assignedColumn=assignedColumnByRow[rowIndex];if(assignedColumn>=0&&assignedColumn<realColumnCount){const candidate=row.find(item=>keyToColumn.get(item.key)===assignedColumn)??null;if(candidate){return{candidate,rank:row.indexOf(candidate),unique:true}}}const fallback=row[0]??null;return{candidate:fallback,rank:fallback?0:null,unique:false}})};

  const normalizeCategoryImageKey = (candidate) => {
    if (!candidate || !candidate.src) return '';
    try {
      const url = new URL(candidate.src, document.baseURI);
      url.search = '';
      url.hash = '';
      return `src:${url.href.toLowerCase()}`;
    } catch (error) {
      return candidate.imageId ? `image:${candidate.imageId}` : `product:${candidate.productId}`;
    }
  };

  const parseCategoryImageCandidates = (item) => {
    const payload = item.querySelector('[data-category-image-candidates]');
    if (!payload) return [];
    try {
      const candidates = JSON.parse(payload.textContent || '[]');
      if (!Array.isArray(candidates)) return [];
      return candidates
        .map((candidate) => ({ ...candidate, key: normalizeCategoryImageKey(candidate) }))
        .filter((candidate) => candidate.key && candidate.src);
    } catch (error) {
      item.dataset.categoryImageSelection = 'invalid-candidate-json';
      return [];
    }
  };

  const applyCategoryImageAssignments = (items) => {
    const candidateRows = items.map(parseCategoryImageCandidates);
    const selections = solveCollectionRailImageAssignment(candidateRows);
    selections.forEach((selection, index) => {
      const item = items[index];
      const image = item.querySelector('.codex-category-children__image');
      const candidate = selection.candidate;
      if (!image || !candidate) {
        item.dataset.categoryImageSelection = 'no-image';
        return;
      }

      image.src = candidate.src;
      image.srcset = [
        `${candidate.src120} 120w`,
        `${candidate.src180} 180w`,
        `${candidate.src240} 240w`,
        `${candidate.src320} 320w`,
        `${candidate.src360} 360w`,
      ].join(', ');
      item.dataset.categoryImageProductId = candidate.productId || '';
      item.dataset.categoryImageId = candidate.imageId || '';
      item.dataset.categoryImageRank = String((selection.rank ?? 0) + 1);
      item.dataset.categoryImageKey = candidate.key;
      item.dataset.categoryImageSelection = selection.unique ? 'unique-assignment' : 'fallback-repeat';
    });
  };

  document.querySelectorAll('[data-category-children-rail]').forEach((rail) => {
    const viewport = rail.closest('.codex-category-children__viewport');
    const previousButton = viewport.querySelector('[data-category-children-previous]');
    const nextButton = viewport.querySelector('[data-category-children-next]');
    const items = Array.from(rail.querySelectorAll('[data-category-child]'));
    const isMadeInItem = (item) => /^Made in\b/i.test(item.dataset.categoryTitle.trim());
    items.sort((left, right) => {
      const countDifference = Number(right.dataset.productCount) - Number(left.dataset.productCount);
      if (countDifference !== 0) return countDifference;
      return left.dataset.categoryTitle.localeCompare(right.dataset.categoryTitle, 'en', { sensitivity: 'base' });
    });

    const firstMadeInIndex = items.findIndex(isMadeInItem);
    if (firstMadeInIndex >= 0) {
      const madeInItems = items
        .filter(isMadeInItem)
        .sort((left, right) => left.dataset.categoryTitle.localeCompare(right.dataset.categoryTitle, 'en', { sensitivity: 'base' }));
      if (madeInItems.length > 1) {
        const otherItems = items.filter((item) => !isMadeInItem(item));
        items.splice(0, items.length, ...otherItems);
        items.splice(firstMadeInIndex, 0, ...madeInItems);
      }
    }

    applyCategoryImageAssignments(items);
    items.forEach((item) => rail.append(item));
    rail.classList.toggle('is-short-rail', items.length <= 4);

    const updateScrollControls = () => {
      const maximumScroll = Math.max(0, rail.scrollWidth - rail.clientWidth);
      const hasOverflow = maximumScroll > 4;
      const currentScroll = Math.min(maximumScroll, Math.max(0, rail.scrollLeft));
      const canScrollPrevious = hasOverflow && currentScroll > 4;
      const canScrollNext = hasOverflow && currentScroll < maximumScroll - 4;
      viewport.classList.toggle('has-overflow', hasOverflow);
      viewport.classList.toggle('can-scroll-previous', canScrollPrevious);
      viewport.classList.toggle('can-scroll-next', canScrollNext);
      previousButton.hidden = !hasOverflow;
      nextButton.hidden = !hasOverflow;
      previousButton.disabled = !canScrollPrevious;
      nextButton.disabled = !canScrollNext;
    };

    const resetRailToStart = () => {
      rail.scrollLeft = 0;
      updateScrollControls();
    };

    const scrollRail = (direction) => {
      const firstItem = items[0];
      const itemWidth = firstItem ? firstItem.getBoundingClientRect().width : rail.clientWidth;
      const gap = Number.parseFloat(getComputedStyle(rail).columnGap) || 0;
      const maximumScroll = Math.max(0, rail.scrollWidth - rail.clientWidth);
      const currentScroll = Math.min(maximumScroll, Math.max(0, rail.scrollLeft));
      const targetScroll = Math.min(maximumScroll, Math.max(0, currentScroll + direction * (itemWidth + gap)));
      rail.scrollTo({ left: targetScroll, behavior: 'smooth' });
    };

    previousButton.addEventListener('click', () => scrollRail(-1));
    nextButton.addEventListener('click', () => scrollRail(1));

    let scrollFrame = null;
    rail.addEventListener('scroll', () => {
      if (scrollFrame !== null) cancelAnimationFrame(scrollFrame);
      scrollFrame = requestAnimationFrame(() => {
        updateScrollControls();
        scrollFrame = null;
      });
    }, { passive: true });

    if ('ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver(updateScrollControls);
      resizeObserver.observe(rail);
    } else {
      window.addEventListener('resize', updateScrollControls);
    }

    resetRailToStart();
    requestAnimationFrame(() => {
      resetRailToStart();
      requestAnimationFrame(resetRailToStart);
    });
    window.addEventListener('pageshow', resetRailToStart);

    let isDragging = false;
    let didDrag = false;
    let pointerId = null;
    let startX = 0;
    let startScrollLeft = 0;

    rail.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      isDragging = true;
      didDrag = false;
      pointerId = event.pointerId;
      startX = event.clientX;
      startScrollLeft = rail.scrollLeft;
    });

    rail.addEventListener('pointermove', (event) => {
      if (!isDragging || event.pointerId !== pointerId) return;
      const distance = event.clientX - startX;
      if (Math.abs(distance) > 5 && !didDrag) {
        didDrag = true;
        rail.setPointerCapture(pointerId);
        rail.classList.add('is-dragging');
      }
      if (!didDrag) return;
      event.preventDefault();
      rail.scrollLeft = startScrollLeft - distance;
    });

    const stopDragging = (event) => {
      if (!isDragging || event.pointerId !== pointerId) return;
      isDragging = false;
      rail.classList.remove('is-dragging');
      if (rail.hasPointerCapture(pointerId)) rail.releasePointerCapture(pointerId);
      pointerId = null;
    };

    rail.addEventListener('pointerup', stopDragging);
    rail.addEventListener('pointercancel', stopDragging);
    rail.addEventListener('click', (event) => {
      if (!didDrag) return;
      event.preventDefault();
      event.stopPropagation();
      didDrag = false;
    }, true);
  });

  } catch(e) { console.error(e); }
})();
})();
